"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var registrationBuilder = function registrationBuilder(_a) {
  var _b = _a.registration,
      registration = _b === void 0 ? [] : _b;

  if (registration.length === 0 || registration.includes('possible') && registration.includes('not-possible')) {
    return '';
  }

  return registration[0] === 'not-possible' ? 'facility_registration_possible:no' : 'facility_registration_possible:yes';
};

var _default = registrationBuilder;
exports["default"] = _default;